import { ref } from 'vue';

/**
 * digitt: DENG-7204 — the Sanity-curated `openConversationTemplates` list (the same one the
 * Digitt Front extension uses), keyed by Twilio Content SID. Cached in localStorage; callers
 * load from cache and only re-fetch (Sanity) on an explicit refresh. Public query API; no auth
 * needed for published content.
 */
const SANITY_TEMPLATES_URL =
  'https://rx1pr21h.api.sanity.io/v2021-10-21/data/query/production?query=*%5B_type%3D%3D%22business%22%5D%7BopenConversationTemplates%7D&perspective=published';
const SANITY_CACHE_KEY = 'digitt-open-conversation-templates';

const toMap = templates => new Map(templates.map(tpl => [tpl.templateId, tpl]));

export function useSanityContentTemplates() {
  const sanityTemplatesById = ref(new Map());

  const loadFromCache = () => {
    try {
      const cached = window.localStorage.getItem(SANITY_CACHE_KEY);
      sanityTemplatesById.value = toMap(cached ? JSON.parse(cached) : []);
    } catch (error) {
      sanityTemplatesById.value = new Map();
    }
  };

  const fetchTemplates = async () => {
    const response = await fetch(SANITY_TEMPLATES_URL);
    const data = await response.json();
    const templates = (data?.result || []).flatMap(
      business => business?.openConversationTemplates || []
    );
    window.localStorage.setItem(SANITY_CACHE_KEY, JSON.stringify(templates));
    sanityTemplatesById.value = toMap(templates);
  };

  // title comes from Sanity (templateName), not Twilio's friendly_name
  const templateTitle = template =>
    sanityTemplatesById.value.get(template.content_sid)?.templateName ||
    template.friendly_name;

  const isCurated = template =>
    sanityTemplatesById.value.has(template.content_sid);

  return {
    sanityTemplatesById,
    loadFromCache,
    fetchTemplates,
    templateTitle,
    isCurated,
  };
}
